/**
 * Symbole der Seitenleiste. Jeder Bereich hat eines, damit die eingeklappte Leiste (nur Symbole) lesbar bleibt. Der Schlüssel ist derselbe wie im Menü: der Pfad des Eintrags
 * oder, bei Modulen ohne eigene Einträge, der Modulschlüssel. Die Symbole sind Linien auf einem 24er Raster und erben die Textfarbe, sie passen sich also Hell und Dunkel von selbst an.
 */
const P = {
  home: 'M3 11 12 3l9 8M5 9.5V20h5v-6h4v6h5V9.5',
  inbox: 'M3 13l3-8h12l3 8M3 13v6h18v-6M3 13h5l1 3h6l1-3h5',
  chat: 'M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12Z',
  offer: 'M6 3h9l4 4v14H6zM14 3v5h5M9 13h7M9 17h5',
  megaphone: 'M3 11v3a1 1 0 0 0 1 1h3l9 4V6L7 10H4a1 1 0 0 0-1 1ZM19 9a4 4 0 0 1 0 6',
  users: 'M16 20v-1.5a3.5 3.5 0 0 0-3.5-3.5h-5A3.5 3.5 0 0 0 4 18.5V20M10 11.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM20 20v-1.5a3.5 3.5 0 0 0-2.5-3.3M15.5 4.7a3.5 3.5 0 0 1 0 6.6',
  book: 'M5 4h11a3 3 0 0 1 3 3v13H8a3 3 0 0 1-3-3zM5 17a3 3 0 0 1 3-3h11M9 8h6',
  list: 'M8 6h12M8 12h12M8 18h12M4 6h.01M4 12h.01M4 18h.01',
  dashboard: 'M4 4h7v7H4zM13 4h7v4h-7zM13 11h7v9h-7zM4 14h7v6H4z',
  contract: 'M6 3h9l4 4v14H6zM14 3v5h5M9 17c1-2 2-2 3 0s2 1 3-1',
  calendar: 'M4 6h16v14H4zM4 10h16M8 3v4M16 3v4',
  check: 'M9 11l3 3 8-8M20 12v7a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 7v5l3 2',
  timer: 'M12 21a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM12 9v4l2.5 2M9.5 2h5M12 2v3M19 7l1.5-1.5',
  route: 'M6 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM18 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM8 17h6a3 3 0 0 0 0-6h-4a3 3 0 0 1 0-6h6',
  contact: 'M4 4h14a2 2 0 0 1 2 2v14H6a2 2 0 0 1-2-2zM12 12a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM8 17c.5-2 2-3 4-3s3.5 1 4 3',
  box: 'M12 3l8 4.5v9L12 21l-8-4.5v-9zM4 7.5l8 4.5 8-4.5M12 12v9',
  folder: 'M3 6a1 1 0 0 1 1-1h5l2 2h9a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z',
  invoice: 'M6 3h12v18l-3-2-3 2-3-2-3 2zM9 8h6M9 12h6',
  inbound: 'M12 3v11M8 10l4 4 4-4M4 15v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4',
  bank: 'M3 9l9-5 9 5M5 9v9M9 9v9M15 9v9M19 9v9M3 20h18',
  chart: 'M4 20V9M10 20V4M16 20v-8M22 20H2',
  report: 'M4 4v16h16M8 15l3-4 3 2 5-6',
  ledger: 'M4 4h16v16H4zM4 9h16M4 14h16M10 4v16',
  car: 'M5 16V11l2-5h10l2 5v5M3 16h18M7 16v3M17 16v3M7.5 13h.01M16.5 13h.01',
  warehouse: 'M3 9l9-5 9 5v11H3zM8 20v-6h8v6',
  asset: 'M3 7h18v13H3zM8 7V4h8v3M3 13h18',
  import: 'M12 3v12M8 7l4-4 4 4M4 15v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4',
  gear: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1Z',
  gift: 'M4 11h16v9H4zM3 7h18v4H3zM12 7v13M12 7c-1.5-3-5-3-5-1 0 1.5 2 1 5 1zM12 7c1.5-3 5-3 5-1 0 1.5-2 1-5 1z',
  dot: 'M12 12h.01',
} as const;

type IconName = keyof typeof P;

/** Symbol je Bereich, Schlüssel wie in navBuilder.ts */
const BY_KEY: Record<string, IconName> = {
  inquiries: 'inbox',
  '/anfragen': 'inbox',
  '/chats': 'chat',
  webchat: 'chat',
  offers: 'offer',
  '/angebote': 'offer',
  '/crm': 'dashboard',
  crm: 'dashboard',
  '/marketing': 'megaphone',
  '/marketing/abonnenten': 'users',
  '/marketing/beitraege': 'book',
  marketing: 'megaphone',
  '/auftragscockpit': 'dashboard',
  '/auftraege': 'list',
  '/gutscheine': 'gift',
  '/rabattcodes': 'offer',
  vouchers: 'gift',
  orders: 'list',
  '/auftragsbuch': 'book',
  ridebook: 'book',
  hr: 'users',
  contracts: 'contract',
  payroll: 'bank',
  '/loehne': 'bank',
  '/loehne/arbeitszeiten': 'timer',
  '/vertraege': 'contract',
  '/kalender/aufgaben': 'check',
  '/kalender/termine': 'calendar',
  calendar: 'calendar',
  shifts: 'clock',
  '/auftragsplanung': 'route',
  contacts: 'contact',
  products: 'box',
  documents: 'folder',
  '/debitoren': 'invoice',
  '/kreditoren': 'inbound',
  '/rechnungen': 'invoice',
  invoices_out: 'invoice',
  '/eingangsrechnungen': 'inbound',
  invoices_in: 'inbound',
  financing: 'bank',
  '/finanzierungen': 'bank',
  '/kontenplan': 'ledger',
  chart: 'ledger',
  '/finanzreport': 'report',
  '/sachposten': 'list',
  reports: 'chart',
  '/auswertungen': 'chart',
  '/flotte': 'car',
  fleet: 'car',
  '/lager': 'warehouse',
  inventory: 'warehouse',
  '/inventar': 'asset',
  '/inventar/anlagenspiegel': 'ledger',
  '/import-export': 'import',
  imports: 'import',
  '/einrichtung': 'gear',
};

/** Symbol der Gruppe, falls ein Eintrag keines hat */
const BY_GROUP: Record<string, IconName> = { crm: 'dashboard', orders: 'list', team: 'users', master: 'folder', finance: 'bank', operations: 'warehouse', system: 'gear' };

/**
 * Symbole aus dem Branding-Kit (public/brand/icon-*.webp, erzeugt mit tools/brand/build-kit.py): CRM, Marketing, Personal, Flotte, Lager und Finanzen. Sie sind mehrfarbig (helle Linie,
 * goldener Akzent) und behalten ihre Farbe auch beim Überfahren und im aktiven Eintrag, die Seitenleiste ist in beiden Designs dunkel.
 */
const KIT_BY_KEY: Record<string, string> = {
  '/crm': 'crm',
  crm: 'crm',
  '/marketing': 'marketing',
  marketing: 'marketing',
  hr: 'personal',
  '/flotte': 'flotte',
  fleet: 'flotte',
  '/lager': 'lager',
  inventory: 'lager',
  '/finanzreport': 'finanzen',
};
const KIT_BY_GROUP: Record<string, string> = { crm: 'crm', team: 'personal', finance: 'finanzen', operations: 'flotte' };

function Kit({ name, size }: { name: string; size: number }) {
  return <img className="sidenav__icon sidenav__icon--kit" src={`/brand/icon-${name}.webp`} alt="" width={size} height={size} decoding="async" />;
}

export function NavIcon({ itemKey, size = 20 }: { itemKey: string; size?: number }) {
  const kit = KIT_BY_KEY[itemKey];
  return kit ? <Kit name={kit} size={size} /> : <Svg name={BY_KEY[itemKey] ?? 'dot'} size={size} />;
}

export function GroupIcon({ groupKey, size = 20 }: { groupKey: string; size?: number }) {
  const kit = KIT_BY_GROUP[groupKey];
  return kit ? <Kit name={kit} size={size} /> : <Svg name={BY_GROUP[groupKey] ?? 'dot'} size={size} />;
}

export function HomeIcon({ size = 20 }: { size?: number }) {
  return <Svg name="home" size={size} />;
}

function Svg({ name, size }: { name: IconName; size: number }) {
  return (
    <svg className="sidenav__icon" viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={P[name]} />
    </svg>
  );
}
